import React from 'react'
import ContractToSignComponent from '../components/Signature/MultipleSigned/ContractToSign/ContractToSignComponent'


export default function ContractsToSign() {
  return <ContractToSignComponent />
}
